module.exports = __webpack_public_path__ + "img/instructivo-inter.ede151da.jpeg";